// extracted by mini-css-extract-plugin
export var hideOnDesktop = "we-are-section-module--hideOnDesktop--F6YkF";
export var photoColumn = "we-are-section-module--photo-column--6WYVq";
export var photoWrapper = "we-are-section-module--photo-wrapper--o91Ps";